import React from "react";

export default function Footer() {
    return (
        <footer>
            © Confections Moufette {new Date().getFullYear()}
        </footer>
    );
}